<div class="m-2 container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10 col-xl-8">
      <form [formGroup]="rideForm" (ngSubmit)="onSubmit()">
        <p-card class="p-4">
          <ng-template #header>
            <div class="flex align-items-center justify-content-between">
              <h2 class="m-0 text-2xl font-bold">{{ pageTitle }}</h2>
            </div>
          </ng-template>
          <!-- Informações Básicas -->
          <div class="mb-4">
            <h3 class="text-lg font-semibold mb-3 text-primary">Informações Básicas</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="field">
                <label for="driverId" class="block text-sm font-medium mb-2">
                  Motorista <span class="text-red-500">*</span>
                </label>
                <p-select 
                  id="driverId"
                  formControlName="driverId"
                  [options]="drivers"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Selecione um motorista"
                  [filter]="true"
                  [showClear]="true"
                  [loading]="isLoadingDrivers"
                  (onFilter)="onDriverFilter($event)"
                  class="w-full"
                  [class.p-invalid]="rideForm.get('driverId')?.invalid && rideForm.get('driverId')?.touched" />
                <small 
                  *ngIf="getFieldError('driverId')" 
                  class="p-error block mt-1">
                  {{ getFieldError('driverId') }}
                </small>
              </div>
              
              <div class="field">
                <label for="date" class="block text-sm font-medium mb-2">
                  Data <span class="text-red-500">*</span>
                </label>
                <input 
                  type="datetime-local" 
                  pInputText 
                  id="date"
                  formControlName="date"
                  placeholder="Selecione a data"
                  class="w-full"
                  [class.p-invalid]="rideForm.get('date')?.invalid && rideForm.get('date')?.touched" />
                <small 
                  *ngIf="getFieldError('date')" 
                  class="p-error block mt-1">
                  {{ getFieldError('date') }}
                </small>
              </div>
            </div>
          </div>

          <p-divider />

          <!-- Informações de Rota -->
          <div class="mb-4">
            <h3 class="text-lg font-semibold mb-3 text-primary">Informações de Rota</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="field">
                <label for="fromCityId" class="block text-sm font-medium mb-2">
                  Cidade de Origem <span class="text-red-500">*</span>
                </label>
                <p-select 
                  id="fromCityId"
                  formControlName="fromCityId"
                  [options]="fromCities"
                  optionLabel="displayName"
                  optionValue="id"
                  placeholder="Selecione a cidade de origem"
                  [filter]="true"
                  [showClear]="true"
                  [loading]="isLoadingFromCities"
                  (onFilter)="onFromCityFilter($event)"
                  class="w-full"
                  [class.p-invalid]="rideForm.get('fromCityId')?.invalid && rideForm.get('fromCityId')?.touched" />
                <small 
                  *ngIf="getFieldError('fromCityId')" 
                  class="p-error block mt-1">
                  {{ getFieldError('fromCityId') }}
                </small>
              </div>
              
              <div class="field">
                <label for="toCityId" class="block text-sm font-medium mb-2">
                  Cidade de Destino <span class="text-red-500">*</span>
                </label>
                <p-select 
                  id="toCityId"
                  formControlName="toCityId"
                  [options]="toCities"
                  optionLabel="displayName"
                  optionValue="id"
                  placeholder="Selecione a cidade de destino"
                  [filter]="true"
                  [showClear]="true"
                  [loading]="isLoadingToCities"
                  (onFilter)="onToCityFilter($event)"
                  class="w-full"
                  [class.p-invalid]="rideForm.get('toCityId')?.invalid && rideForm.get('toCityId')?.touched" />
                <small 
                  *ngIf="getFieldError('toCityId')" 
                  class="p-error block mt-1">
                  {{ getFieldError('toCityId') }}
                </small>
              </div>
            </div>
          </div>


          <!-- Mensagem de Erro -->
          <div *ngIf="errorMessage" class="mb-4">
            <p-message 
              severity="error" 
              [text]="errorMessage" 
              [closable]="false" />
          </div>
        </p-card>

        <!-- Botões de Ação -->
        <div class="bg-white rounded-lg shadow-1 p-4 mt-3">
          <div class="flex justify-content-end gap-2">
            <p-button 
              label="Cancelar" 
              severity="secondary" 
              (onClick)="onCancel()"
              [disabled]="isLoading"
              icon="pi pi-times" />
            
            <p-button 
              [label]="submitButtonText"
              severity="primary"
              type="submit"
              [disabled]="isLoading || rideForm.invalid"
              [loading]="isLoading"
              icon="pi pi-check" />
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
